<template>
  <layout-header />
  <router-view />
</template>

<script>
import LayoutHeader from "./Header.vue";

export default {
  name: "Header",
  components: { LayoutHeader },
};
</script>
